export default "__VITE_ASSET__92724772__"